module.exports = __webpack_public_path__ + "static/media/kaw.9ff6cf91.ogg";